import { CompositionService } from "../../../librettoEditor/services/CompositionService";
import { ApplicationStore } from "../../../librettoEditor/store/ApplicationStore";
import type { ScriptChunkV1 } from "../../../librettoEditor/types/ScriptChunk";

type SceneRange = {
    startSec: number;
    endSec: number;
};

export const getCompatibleScriptChunkClipboard = (scriptClip: any): ScriptChunkV1 | null => {
    const chunk = ApplicationStore.getScriptChunkClipboard();
    if (!chunk) return null;

    const clipId = String(scriptClip?.id ?? "");
    const chunkClipId = String((chunk as any)?.scriptClipId ?? "");
    if (!clipId || !chunkClipId || clipId !== chunkClipId) return null;

    const dur = Number((chunk as any)?.durationSec ?? 0);
    if (!Number.isFinite(dur) || dur <= 1e-3) return null;

    return chunk;
};

export const pasteScriptChunkIntoScene = async (args: {
    scene: SceneRange;
    chunk: ScriptChunkV1;
}): Promise<boolean> => {
    const clip: any = CompositionService.getScriptLayerClip?.();
    if (!clip || String(clip?.type ?? "") !== "script") return false;

    const clipId = String(clip?.id ?? "");
    const chunkClipId = String((args.chunk as any)?.scriptClipId ?? "");
    if (!clipId || !chunkClipId || clipId !== chunkClipId) return false;

    const start = Number(args.scene?.startSec ?? NaN);
    const end = Number(args.scene?.endSec ?? NaN);
    const EPS = 1e-3;
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start + EPS) return false;

    CompositionService.beginScriptLayerBatch();
    try {
        // Replace the target empty scene region, then insert the copied chunk at the same boundary.
        CompositionService.cutScriptLayerRange(start, end, { transcriptMode: "delete" });
        const ok = await CompositionService.pasteScriptChunk(start, args.chunk);
        return Boolean(ok);
    } catch (e) {
        console.warn("[scriptChunkScenePaste] Failed pasting script chunk into empty scene", e);
        return false;
    } finally {
        try {
            await CompositionService.endScriptLayerBatch();
        } catch {}
    }
};
